import { render, staticRenderFns } from "./BulkEditJobItems.vue?vue&type=template&id=bd443550&scoped=true"
import script from "./BulkEditJobItems.vue?vue&type=script&lang=ts"
export * from "./BulkEditJobItems.vue?vue&type=script&lang=ts"
import style0 from "./BulkEditJobItems.vue?vue&type=style&index=0&id=bd443550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd443550",
  null
  
)

export default component.exports